var map = {
	"./ITC.webp": 9794,
	"./Marriot.webp": 4710,
	"./ananta.webp": 9943,
	"./apollo.webp": 4291,
	"./bikanervala.webp": 912,
	"./discovery.webp": 9690,
	"./fairmont.webp": 2044,
	"./haldiram.webp": 566,
	"./mcdonalds.webp": 3537,
	"./oberoi.webp": 3934,
	"./radisson.webp": 7077,
	"./reliance trends.webp": 5443,
	"./sayaji.webp": 3747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5335;